<template>
  <div>
    <header>
      <Header />
    </header>
    <div>
      <div id="main">
        <section class="updateInfo">
          <div class="updateInfoTitle">
            <div class="inner4">
              <h1>アップデート情報</h1>
              <p class="titleSub">Update Information</p>
            </div><!-- /inner4-->
          </div><!-- /updateInfoTitle-->

          <div class="updateInfoBody">
            <section class="updateBlock" v-if="this.isClosed()">
              <div class="inner2">
                <h2>2022年10月23日：「東京カメラ部2022写真展 Online Exhibition」閉幕いたしました</h2>
                <div class="updateBlockInner">
                  <p class="updateMessage">
                  「東京カメラ部2022写真展 Online Exhibition」へ多くのアクセスをいただき、誠にありがとうございました。本写真展は2022年10月22日をもって終了しました。<br>
                  写真展終了に伴い「応援メッセージ・感想」へのコメント受付は終了となります。 今までに皆様から寄せられたコメントや、展示作品、ポートフォリオについては引き続き閲覧可能です。オンライントークショーについてもアーカイブ動画やレポートページを用意していますので、引き続き本サイトをお楽しみください。
                  </p>
                </div>
              </div><!-- /inner2-->
            </section><!-- /updateBlock-->

            <section class="updateBlock">
              <div class="inner2">
                <h2>2022年9月16日：「東京カメラ部2022写真展 Online Exhibition」開幕いたしました。</h2>
                <div class="updateBlockInner">
                  <p class="updateMessage"></p>
                </div>
              </div><!-- /inner2-->
            </section><!-- /updateBlock-->

          </div><!-- /updateInfoBody-->
        </section><!-- /updateInfo-->
      </div><!-- /main-->
    </div>
    <Footer />
    <div class="actionMenu">
      <UpButton />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'
import OpeningUtil from '@/util/OpeningUtil'
import moment from 'moment-timezone'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {
      timerId: null,
      nowDateTime: null
    }
  },
  computed: {
    ...mapGetters(['winners', 'winnersByAwardType', 'areas'])
  },
  methods: {
    // 写真展オープン中か、本番環境以外の場合、フラグにtrueを設定
    isClosed () {
      return OpeningUtil.isClosed()
    },
    setTitleAndDescription (to) {
      document.title = to.meta.title ? to.meta.title : ''
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', to.meta.desc ? to.meta.desc : '')
    },
    // 現在時刻のセット
    setNow () {
      this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      this.timerId = setInterval(function () {
        this.nowDateTime = moment().tz('Asia/Tokyo').format('YYYYMMDD HH:mm:ss')
      }.bind(this), 1000)
    },
    isClose () {
      return true
      // return (this.nowDateTime > '20201031 23:59:59')
    }
  },
  created () {
    this.setNow()
  },
  beforeDestroy () {
    clearInterval(this.timerId)
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
</style>
